import React, { useState, useEffect } from 'react'
import './css/screen3.css';  
import { getRedeemPacks,redeemPoints } from '../services/home';
import { NavLink } from 'react-router-dom';
import {findLevel} from '../utils/levels'
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import {Loader} from "../utils/loader";


const Redeem = () => {
    const [packs, setPacks] = useState([]);
    const [points, setPoints] = useState(0);
    const [status, setStatus] = useState(0);
    const [selectedPack, setSelectedPack] = useState(1);
    const { t  } = useTranslation();
    const [loading, setLoading] = useState(false);
    const language = localStorage.getItem('selectedLanguage');
    const [ButtonDisabled, setButtonDisabled] = useState(true);
    const [message, setMessage] = useState({message: "",error: true});
    const [btnLoading, setBtnLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getRedeemPacks().then((res) => {
            setPacks(res.prizePacks);
            setPoints(res.points);
            setStatus(res.status);  
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
    }, [])

   const redeemPointsHandler = () => {
    setMessage({ message: "", error: true});
    setBtnLoading(true);
    //console.log(selectedPack);
     redeemPoints({redeemPackId:selectedPack}).then((res) => {       
          setBtnLoading(false);
          if(res.responseCode==203){
               setMessage({message: t('143'),error: true,});
          }
          else if(res.responseCode==200)
          {
            const data=res.data;
            setPacks(data.prizePacks);
            setPoints(data.points);
            setStatus(data.status); 
            setMessage({message: t('142'),error: false,});
          } else setMessage({message: t('132'),error: true,});
          })
          .catch((err) => {
            console.log(err);
            setMessage({message: t('132'),error: true,});
            setBtnLoading(false);
          });
  };
   const handlePackSelection = (pack) => {
    setSelectedPack(pack.id);
  };

  return ( 
    loading ? <Loader />:
    <div className='history'> 
      <div className="maine-div">
          <div className="container-fluid box-wrapper difficult"> 
             
            <div className="page-header pb-5">
                <div className="box-wrapper mx-auto text-center position-relative">
                    <NavLink to="/profile" className="page-header-back"><img src="/image/back.png" className='arrow' alt="Avatar" /></NavLink>
                    <span className="modal-level-title levels-title">{t('140')}</span>
                </div>
            </div> 

            <div className="card-simple-outer">
                <ul className="history-list-wrapper">                
                  <li key="Stars" className="history-list">
                      <div className="history-list-info">
                      <p><b>{t('95')}</b></p>
                      </div>
                      <div className="history-data">
                          <span>{points}</span>
                      </div>
                  </li>
                </ul>
            </div>

            <div className="card-simple-outer">
                <div className="text-center login-info">
                    <h3 className="login-title-red mb-3 mt-3">{t("141")}</h3>
                    {
                      packs && packs.map((pack) => (<>
                           <label key={pack.id} className="pack">
                                    <input type="radio" id="rd1" checked={selectedPack === pack.id} onChange={() => handlePackSelection(pack)} />
                                    {" "+t('pack'+pack.id)}
                              </label><br/>
                          </>
                       ))}
                       <br/>
                        {message.message && (<div className="mb-3"><p className={`alert alert-${ message.error ? "danger" : "success"}`} > {message.message} </p></div>)}
                        {btnLoading ? <Loader />:<>
                         <div className="row text-center" >
                          <div className="col-3"></div>
                          <div className="col-6">
                          <button className="pack-btn btn btn-primary btn-pm-custom-red" onClick={redeemPointsHandler} >{ t("109") }</button>
                          </div>
                          <div className="col-3"></div>
                          </div>
                          <br/><br/>
                          </>
                        }
                    </div>
                  
            </div> 
          </div>
      </div> 
    </div> 
  )
}

export default Redeem